import { Badge } from "reactstrap";
import INSTALLATION_STEPS from "./installationConstants";

export default function StepBadge({ step }) {
  const config = INSTALLATION_STEPS[step];
  if (!config) return <span>{step}</span>;
  return (
    <Badge style={{ backgroundColor: `var(--${config.color})`, pointerEvents: "none" }} pill>
      {config.label}
    </Badge>
  );
}
